import { task } from "../../../../types/task";
import MenuItem from "@mui/material/MenuItem";
import { Select } from "@mui/material";
import { GET_USERS_CONDITIONAL } from "../../../../gqls/user";
import { useMutation, useQuery } from "@apollo/client";
import { UPDATE_TASK_BY_ID } from "../../../../gqls/task";
import useAddCustomerHistory from "../../../../hooks/useAddCustomerHistory";
import { useState } from "react";

interface props {
  task: task;
}

export default function TaskAssignedToControl({ task }: props) {
  const { data } = useQuery(GET_USERS_CONDITIONAL, {
    variables: {
      where: {
        companyId: {
          _eq: task.companyId,
        },
        status: {
          considerActive: {
            _eq: true,
          },
        },
      },
    },
  });

  const users = data?.users;

  const [updateTask] = useMutation(UPDATE_TASK_BY_ID);
  const { addHistory } = useAddCustomerHistory();

  const [isDisabled, setIsDisabled] = useState(false);

  const update = (id: number) => {
    if (task.assignedToId == id) {
      return;
    }

    const user = users?.find(u => u.id == id);

    const proceed = confirm(`작업자를 지정하시겠습니까? - ${user?.name}`);

    if (!proceed) return;

    updateTask({
      variables: {
        id: task.id,
        set: {
          assignedToId: id,
        },
      },
      onError(error) {
        console.log(error);
      },
    });

    setIsDisabled(true);

    addHistory({
      customerId: task.customerId,
      message: `작업자 변경 [${user?.name || "미정"}]`,
      type: "task",
      taskId: task.id,
      link: `/customers/detail/${task.customerId}/progress/task/${task.id}`,
    });
  };

  if (!users) return null;

  return (
    <Select
      margin="none"
      size="small"
      required
      className="shadow-md"
      color="success"
      value={task.assignedToId || 0}
      onChange={e => update(Number(e.target.value))}
      disabled={isDisabled}
    >
      <MenuItem value={0}>
        {users.length === 0
          ? "가용 작업자가 없습니다"
          : "작업자를 선택해주세요"}
      </MenuItem>
      {users.map(user => (
        <MenuItem value={user.id} key={user.id}>
          {user.name}
        </MenuItem>
      ))}
    </Select>
  );
}
